var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorDoodle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 129,
    viewBox: "0 0 132 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler:location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M115.5 16.125L79.75 112.875C79.5087 113.39 79.1213 113.826 78.6338 114.131C78.1463 114.437 77.5792 114.6 77 114.6C76.4208 114.6 75.8537 114.437 75.3662 114.131C74.8787 113.826 74.4913 113.39 74.25 112.875L55 75.25L16.5 56.4375C15.9734 56.2017 15.5272 55.8231 15.2143 55.3466C14.9015 54.8702 14.7352 54.3161 14.7352 53.75C14.7352 53.1839 14.9015 52.6298 15.2143 52.1533C15.5272 51.6769 15.9734 51.2983 16.5 51.0625L115.5 16.125Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorDoodle);
export default __webpack_public_path__ + "static/media/cursorDoodle.10654e549346f231c7932e50bc1b7d67.svg";
export { ForwardRef as ReactComponent };